var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationPointRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00001 0.333496C3.32001 0.333496 0.333344 3.32016 0.333344 7.00016C0.333344 10.6802 3.32001 13.6668 7.00001 13.6668C10.68 13.6668 13.6667 10.6802 13.6667 7.00016C13.6667 3.32016 10.68 0.333496 7.00001 0.333496ZM6.33334 10.3335V9.00016H7.66668V10.3335H6.33334ZM6.33334 3.66683V7.66683H7.66668V3.66683H6.33334Z",
    fill: "#B3261E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationPointRed);
export default __webpack_public_path__ + "static/media/exclamation_point_red.0de497972b4fd21a5c80d4dde1a4c324.svg";
export { ForwardRef as ReactComponent };